export const CHANNEL_KEY = 'channel';
export const EMAIL_KEY = 'email';
export const REFERENCE_KEY = 'ref';

export const Channel = {
  DEFAULT: 'default',
  VODAPAY: 'vodapay',
  VODACOM_BUSINESS: 'vodacombusiness',
};
